import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import { map, Observable } from 'rxjs';

import * as DataAccessFairsActions from './data-access-fairs.actions';
import * as DataAccessFairsSelectors from './data-access-fairs.selectors';

import { FairConfiguration } from '../../../interfaces/environment.interfaces';

@Injectable()
export class DataAccessFairsFacade {
  fairsConfig$ = this.store.pipe(select(DataAccessFairsSelectors.getFairsConfig));
  fair$ = this.store.pipe(select(DataAccessFairsSelectors.getFair));
  fairs$ = this.store.pipe(
    select(DataAccessFairsSelectors.getFairsConfig),
    map((fairsConfig) => fairsConfig.fairs),
    map((fairs) =>
      Object.keys(fairs).map((id) => ({
        ...fairs[id],
        id,
      }))
    )
  );
  fairId$ = this.store.pipe(select(DataAccessFairsSelectors.getActiveFairId));
  trackingFairId$ = this.store.pipe(select(DataAccessFairsSelectors.getActiveTrackingFairId));
  fairConfig$ = this.store.pipe(select(DataAccessFairsSelectors.getActiveFairConfig));
  insightsId$ = this.store.pipe(select(DataAccessFairsSelectors.getInsightsId));
  isBauInsights$ = this.store.pipe(select(DataAccessFairsSelectors.getIsBauInsights));
  fairDirectory$ = this.store.pipe(select(DataAccessFairsSelectors.getFairDirectory));
  fairLoading$ = this.store.pipe(select(DataAccessFairsSelectors.getActiveFairLoading));
  fairError$ = this.store.pipe(select(DataAccessFairsSelectors.getActiveFairError));

  fairIdFromRoute$ = this.store.pipe(select(DataAccessFairsSelectors.getFairIdFromRoute));

  constructor(private readonly store: Store) {}

  getFairConfig(fairId: string): Observable<FairConfiguration> {
    return this.store.pipe(select(DataAccessFairsSelectors.getFairConfig, { fairId }));
  }

  appOpened() {
    this.store.dispatch(DataAccessFairsActions.appOpened());
  }

  fairsPageOpened() {
    this.store.dispatch(DataAccessFairsActions.fairsPageOpened());
  }
}
